import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthAcceptInviteComponent } from './components/auth-accept-invite/auth-accept-invite.component'
import { AuthFinishInviteComponent } from './components/auth-finish-invite/auth-finish-invite.component'
import { AuthShellComponent } from './components/auth-shell/auth-shell.component'
import { AuthVerifyEmail } from './components/auth-verify-email/auth-verify-email.component'
import { AuthComponent } from './components/auth/auth.component'
import { FinishResetPasswordComponent } from './components/finish-reset-password/finish-reset-password.component'
import { ResetPasswordComponent } from './components/reset-password/reset-password.component'

const routes: Routes = [
  {
    path: 'auth',
    component: AuthShellComponent,
    children: [
      { path: 'login', component: AuthComponent },
      { path: 'acceptInvite', component: AuthAcceptInviteComponent },
      { path: 'finishInvite', component: AuthFinishInviteComponent },
      { path: 'verifyEmail', component: AuthVerifyEmail },
      { path: 'startResetPassword', component: ResetPasswordComponent },
      { path: 'resetPassword', component: FinishResetPasswordComponent },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
